import { useOktaAuth } from "@okta/okta-react";
import { isTokenExpired } from "shared/helpers/OktaAuthHelpers";

//if we get a 401 error, check if the token is valid and redirect to login page if not
export function useOktaHelpers() {
  const { oktaAuth } = useOktaAuth();

  function isTokenValid() {
    const accessToken = oktaAuth.getAccessToken();
    return !isTokenExpired(accessToken);
  }

  function invalidTokenOnErrorHandler(err) {
    //if we get a 401 error, check if the token is valid and redirect to login page if not

    if (err.response && err.response.status === 401) {
      //redirect the user to the login page

      if (!isTokenValid()) {
        //alert("Invalid token, redirecting to login page");
        window.location.href = "/login";
      }
    }
  }

  return {
    invalidTokenOnErrorHandler,
  };
}
